import { TPagination } from './common';
import { TSystemCredential } from './credentials';

export enum EAgentExecutionStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
  IN_PROGRESS = 'in-progress',
}

export enum EAgentSchemaType {
  IMAGE = 'image',
  FILE = 'file',
  TEXT = 'text',
}

export enum EAgentService {
  N8N = 'n8n',
  NATIVE = 'native',
}

export type TAgent = {
  referenceId: string;
  name: string;
  description: string;
  category: string;
  schema: {
    input: {
      [key: string]: {
        type: string;
        description?: string;
      }
    },
    output: {
      [key: string]: {
        type: EAgentSchemaType;
        description: string;
      }
    }
  };
  service: EAgentService;
  credentials: TSystemCredential[];
  assignCustomers: TAssignedCustomers[];
  createdAt: string;
}

export type TAgentResponse = {
  items: TAgent[];
  pagination: TPagination;
}

export type TAssignedCustomers = {
  customerId: string;
  customerName: string;
  agentId: string;
  agentName: string;
}

export type TAgentMetadata = {
  input?: Record<string, any>;
  output?: Record<string, any>;
  error?: string;
  schema?: {
    output?: Record<string, { type: EAgentSchemaType; description: string }>;
  };
}

export type TSocketAgentLog = {
  createdAt: string;
  finishedAt?: string;
  status?: EAgentExecutionStatus;
  error?: string;
  output?: Record<string, any>;
}

export type TSocketAgentErrorLog = {
  code: number;
  message: string;
  createdAt?: string;
}

export const isErrorLog = (log: TSocketAgentLog | TSocketAgentErrorLog): log is TSocketAgentErrorLog =>
  'code' in log && 'message' in log;

export type TAgentExecution = {
  executionId: string;
  customerAgentId: string;
  customerName?: string;
  createdAt: string;
  finishedAt: string;
  status: EAgentExecutionStatus;
  metadata: TAgentMetadata;
}

export type TAgentProperty = {
  propertyName: string;
  value: string | string[];
}

export type TRunAgentParams = {
  agent: TAgent;
  properties: TAgentProperty[];
  configId: string;
}

export type TConnectedAgent = {
  agentId: string;
  agentName: string;
}